export const thankYouPage = {
  title: 'Thank You Page',
  dialogTitle: {
    thankYouForContact: 'Thank you for contacting us, your',
    emailedShortly: 'will be emailed shortly.',
  },
  serviceType: {
    translationquote: 'Translation quote',
    copywritingquote: 'Transcreation quote',
    interpretingquote: 'Interpreting quote',
    multilingualdtpquote: 'Multilingual DTP quote',
    proofreadingquote: 'Proofreading quote',
    audiotranscriptionquote: 'Audio Transcription quote',
    subtitlingquote: 'Subtitling quote',
    voiceoverquote: 'Voice Over quote',
  },
  altImg: 'Message saying thank you.',
};
